/*
  a collection of easing functions
 */
game.config.easings = {
  EASING_TILES_MOVEMENT: "cubic-bezier(0.403, 0.543, 0.754, 1)"
};
